// extracted by mini-css-extract-plugin
module.exports = {"col":"col_col__3Hy7E","col12":"col_col12__16J3V","col8":"col_col8__1btG9","col4":"col_col4__1iuaB"};